import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AppCtx = createContext(null);

export const AppProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("ng-theme") || "light");
  const [lang, setLang] = useState(() => localStorage.getItem("ng-lang") || "en");
  const [saved, setSaved] = useState(() => JSON.parse(localStorage.getItem("ng-saved") || "[]"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("ng-theme", theme);
  }, [theme]);

  useEffect(() => localStorage.setItem("ng-lang", lang), [lang]);
  useEffect(() => localStorage.setItem("ng-saved", JSON.stringify(saved)), [saved]);

  useEffect(() => {
    const token = localStorage.getItem("ng-token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api.get("/auth/me").then(r => setUser(r.data)).catch(() => {
        localStorage.removeItem("ng-token");
        delete api.defaults.headers.common["Authorization"];
      });
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.token) {
      localStorage.setItem("ng-token", r.data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${r.data.token}`;
    }
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("ng-token");
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
  }, []);

  const toggleSave = (story) => {
    const id = story.id;
    setSaved(s => s.find(x => x.id === id)
      ? s.filter(x => x.id !== id)
      : [{ id, slug: story.slug, title: story.title, cover_image: story.cover_image, category_id: story.category_id }, ...s]);
  };
  const isSaved = (id) => saved.some(s => s.id === id);

  const value = {
    theme, setTheme, toggleTheme: () => setTheme(t => t === "dark" ? "light" : "dark"),
    lang, setLang, user, login, logout, saved, toggleSave, isSaved,
  };
  return <AppCtx.Provider value={value}>{children}</AppCtx.Provider>;
};

export const useApp = () => useContext(AppCtx);

export const t = (en, bn, lang) => (lang === "bn" && bn) ? bn : en;
